// extracted by mini-css-extract-plugin
export default {"business_customer":"BusinessCustomer_business_customer__6c6hU","tel":"BusinessCustomer_tel__HJ1EL","mail":"BusinessCustomer_mail__EF-Fz"};